<!-- Get users lengs in game and subscribe to users online -->
<template>
  <span v-if="!users.lenght" class="spinner-grow" role="status"> </span>
  <span v-else
    >{{ users.lenght }} {{ users.online ? " / " + users.online : "" }}</span
  >
</template>

<script>
const allGames = "All games";
const cmdLenght = "users.length";
const cmdLenghtGame = "users.length.game";
const cmdLenghtGameUnsibscribe = "users.length.game.unsubscribe";

export default {
  name: "UsersLength",

  props: {
    game: String,
  },

  data() {
    return {
      users: {
        lenght: 0, // Number of users
        online: 0, // Number of users online
      },
      gamePrev: "",
    };
  },

  mounted() {
    const that = this;

    // Create reader to receive data from WebRTC Data Channel
    this.reader = this.teoweb.addReader(function (gw, data) {
      if (gw.err) {
        return;
      }

      switch (gw.command) {
        case cmdLenghtGame + "/" + that.game: {
          const resp = JSON.parse(data);
          that.users.lenght = resp.num;
          that.users.online = resp.online;
          break;
        }
      }
    });

    this.check = this.whenConnectedLogin(() => {
      this.getUsersLenght(this.game);
    });
  },

  unmounted() {
    this.unsubscribeUsersLenght(this.game);
    this.teoweb.delReader(this.reader);
    this.check.stop();
  },

  watch: {
    game() {
      this.unsubscribeUsersLenght(this.gamePrev);
      this.getUsersLenght(this.game);
    },
  },

  methods: {
    /**
     * getUsersLenght - Sends a command to the WebRTC server to get the number of users.
     * @param {string} game - The game name to get the number of users for. If empty or
     *   "All games", gets the number of users for all games.
     */
    getUsersLenght(game) {
      let that = this;
      this.users.lenght = "";
      this.gamePrev = this.game;

      // All game mode
      if (game == "" || game == allGames) {
        // Send cmdLenght command with parameter name to WebRTC server
        // to get the number of users for all games.
        this.sendCmd(cmdLenght).then(
          // Process success answer
          (data) => {
            that.users.lenght = JSON.parse(data);
            that.users.online = 0;
          },
          // Process an error
          (err) => console.error("cmdLenght error:", err)
        );

        return;
      }

      // Game mode
      // Send cmdLenghtGame command with parameter name to WebRTC server
      // to get the number of users for the specified game.
      this.teoweb.sendCmd(cmdLenghtGame + "/" + game);
    },

    unsubscribeUsersLenght(game) {
      this.sendCmd(cmdLenghtGameUnsibscribe + "/" + game).then(
        // Process success answer
        () => {},
        // Process an error
        (err) => console.error("cmdLenghtGameUnsibscribe", game, "error:", err)
      );
    },
  },
};
</script>

<style scoped>
.spinner-grow {
  width: 15px;
  height: 15px;
}
</style>
